/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const AcknowledgeIncidentRecordFile = zod.object({
  "incidentRecordId": zod.string().uuid().optional(),
  "id": zod.string().uuid().optional(),
  "isAcknowledged": zod.boolean().optional()
});

export type AcknowledgeIncidentRecordFile = zod.input<typeof AcknowledgeIncidentRecordFile>;
export type AcknowledgeIncidentRecordFileOutput = zod.output<typeof AcknowledgeIncidentRecordFile>;
